/**
 * Shipping & Delivery country lookup table for /pages/delivery.
 * Plain JS (no React/build step); see git history for the previous
 * React/Webpack bundle (react-shipping-table.js).
 */
(function () {
  'use strict';

  // Rows are rendered by sections/shipping-table.liquid from the shipping_table metaobject.
  function readShippingData() {
    var dataEl = document.getElementById('shippingTableData');
    var rows = [];
    try {
      rows = JSON.parse(dataEl ? dataEl.textContent : '[]');
    } catch (e) {
      rows = [];
    }
    rows.sort(function (a, b) {
      return String(a.label).localeCompare(String(b.label));
    });
    var data = {};
    rows.forEach(function (row) {
      if (row && row.code && row.label) data[row.code] = row;
    });
    return data;
  }

  var SHIPPING_DATA = readShippingData();

  var ROOT_ID = 'shippingTable';

  function el(tag, className, html) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (html !== undefined) node.innerHTML = html;
    return node;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function deliveryDaysText(days) {
    if (!days) return '';
    return '(' + days + (String(days).trim() === '1' ? ' business day)' : ' business days)');
  }

  function renderRow(service) {
    var row = el('div', 'shipping-table-details-container');

    var details = el('div', 'shipping-table-details-container-details shipping-table-align-center');
    if (service.courier) details.appendChild(el('h4', 'country', escapeHtml(service.courier)));
    details.appendChild(el('p', 'name', escapeHtml(deliveryDaysText(service.deliveryDays))));
    row.appendChild(details);

    var orderBy = el('div', 'shipping-table-details-container-order-by shipping-table-align-center');
    orderBy.appendChild(el('h4', 'shipping-time', '3:30pm HKT'));
    orderBy.appendChild(el('p', 'name', 'Monday - Friday'));
    row.appendChild(orderBy);

    var fulfilBy = el('div', 'shipping-table-details-container-time shipping-table-align-center');
    fulfilBy.appendChild(el('h4', 'name shipping-table-bold', 'Dispatch by <br> next business day'));
    row.appendChild(fulfilBy);

    var notAvailable = !service.freeShipping || service.freeShipping === 'Not Available';
    var freeShipping = escapeHtml(service.freeShipping);
    var cost = el('div', 'shipping-table-details-container-cost shipping-table-align-center');
    var freeLine = el('p', 'shipping-table-details-container-cost-align');
    freeLine.innerHTML =
      '<span style="font-weight:800"> FREE SHIPPING <br></span>' +
      (notAvailable
        ? '<span class="cost">Not Available</span>'
        : '<span class="cost">Orders ' + freeShipping + ' and over</span>') +
      '<br>';
    cost.appendChild(freeLine);
    var costLine = el('p', 'shipping-table-details-container-cost-align');
    costLine.innerHTML =
      '<span style="font-weight:800"> Estimate shipping cost <br></span>' +
      '<span style="font-weight:800" class="cost">' + escapeHtml(service.cost) + ' <br></span>' +
      (notAvailable ? '' : '<span class="cost">Orders under ' + freeShipping + ' </span>');
    cost.appendChild(costLine);
    row.appendChild(cost);

    return row;
  }

  function buildSelect() {
    var select = el('select', 'shipping-country-select');
    select.setAttribute('aria-label', 'Choose your country');

    var placeholder = el('option', null, 'CHOOSE YOUR COUNTRY');
    placeholder.value = '';
    placeholder.disabled = true;
    placeholder.selected = true;
    select.appendChild(placeholder);

    Object.keys(SHIPPING_DATA).forEach(function (code) {
      var option = el('option');
      option.textContent = SHIPPING_DATA[code].label;
      option.value = code;
      select.appendChild(option);
    });

    return select;
  }

  function buildTable() {
    var container = el('div', 'shipping-table-container');

    var headerGeneral = el('div', 'shipping-table-header-general');
    headerGeneral.appendChild(el('span', null, 'SHIPPING TIMEFRAMES'));
    container.appendChild(headerGeneral);

    var select = buildSelect();
    container.appendChild(select);

    var header = el('div', 'shipping-table-header');
    ['DELIVERY OPTIONS', 'ORDER BY', 'FULFIL BY', 'COST'].forEach(function (label) {
      header.appendChild(el('span', null, label));
    });
    container.appendChild(header);

    var rows = el('div', 'shipping-table-rows');
    container.appendChild(rows);

    select.addEventListener('change', function () {
      rows.innerHTML = '';
      var service = SHIPPING_DATA[select.value];
      if (service) rows.appendChild(renderRow(service));
    });

    return container;
  }

  function buildTerms() {
    var terms = el('div', 'shipping-terms-container');
    terms.innerHTML =
      '<p>We know you\'re excited to receive your package! Check out our full FAQ Page. ' +
      '<a href="https://www.lmching.com/apps/help-center">Click Here</a>. <br>' +
      'If you need any assistance, don\'t hesitate to reach out to our team. ' +
      '<a href="https://www.lmching.com/pages/contact-us">Click Here</a>.<br>' +
      'Remark: we currently do not provide service to countries which are not listed above.</p>';
    return terms;
  }

  function buildFaq() {
    var wrap = el('div', 'shipping-general-container');
    wrap.innerHTML = `<div class="shipping-accordion-container"><div class="accordion">
        <details class="accordion__item">
          <summary class="accordion__heading">
            <span class="accordion__button" aria-expanded="false" role="button" tabindex="-1">
              Shipping Courier Partners
              <span class="icon icon--rotate" data-icon="down-caret"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="down-caret"><path stroke="black" stroke-width="2" d="M96.4,25.73a2,2,0,0,0-2.82,0l-9.66,9.81a2,2,0,0,0-.78.47L50,69.17,16.86,36a2,2,0,0,0-.78-.47L6.42,25.75a2,2,0,1,0-2.84,2.81l45,45.69a2,2,0,0,0,2.84,0l45-45.69A2,2,0,0,0,96.4,25.73Z"></path></g></svg></span>
            </span>
          </summary>
          <div class="accordion__panel">
            <p>All International orders will be fulfilled by DHL, DPEX, Fedex and Aramex.</p>
            <p>Orders from Hong Kong and Macau will be fulfilled by SF Express.</p>
            <p>On certain occasions, we may opt for other courier services to better suit our customers needs.</p>
          </div>
        </details>
        <details class="accordion__item">
          <summary class="accordion__heading">
            <span class="accordion__button" aria-expanded="false" role="button" tabindex="-1">
              Delivery Timeframes
              <span class="icon icon--rotate" data-icon="down-caret"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="down-caret"><path stroke="black" stroke-width="2" d="M96.4,25.73a2,2,0,0,0-2.82,0l-9.66,9.81a2,2,0,0,0-.78.47L50,69.17,16.86,36a2,2,0,0,0-.78-.47L6.42,25.75a2,2,0,1,0-2.84,2.81l45,45.69a2,2,0,0,0,2.84,0l45-45.69A2,2,0,0,0,96.4,25.73Z"></path></g></svg></span>
            </span>
          </summary>
          <div class="accordion__panel">
            <p>The estimated time for delivery to all international countries would be 3-7 business days after the order has been dispatched from our warehouse.</p>
            <p>The estimated time for delivery to any Hong Kong and Macau address would be 2 business days.</p>
            <p>Times listed above are estimates and to be used as a guide only and do not account for any delays with the carrier that may occur outside of our control.</p>
          </div>
        </details>
        <details class="accordion__item">
          <summary class="accordion__heading">
            <span class="accordion__button" aria-expanded="false" role="button" tabindex="-1">
              Order Dispatch Time
              <span class="icon icon--rotate" data-icon="down-caret"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="down-caret"><path stroke="black" stroke-width="2" d="M96.4,25.73a2,2,0,0,0-2.82,0l-9.66,9.81a2,2,0,0,0-.78.47L50,69.17,16.86,36a2,2,0,0,0-.78-.47L6.42,25.75a2,2,0,1,0-2.84,2.81l45,45.69a2,2,0,0,0,2.84,0l45-45.69A2,2,0,0,0,96.4,25.73Z"></path></g></svg></span>
            </span>
          </summary>
          <div class="accordion__panel">
            <p>Upon ordering and payment confirmation, items will be shipped within 1 working day.</p>
            <p>A confirmation e-mail will be sent to you once you have successfully placed an order.</p>
            <p>Tracking code will be sent to you in a separate email within 24 hours after your order is shipped.</p>
          </div>
        </details>
        <details class="accordion__item">
          <summary class="accordion__heading">
            <span class="accordion__button" aria-expanded="false" role="button" tabindex="-1">
              Customs and Duty charges
              <span class="icon icon--rotate" data-icon="down-caret"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="down-caret"><path stroke="black" stroke-width="2" d="M96.4,25.73a2,2,0,0,0-2.82,0l-9.66,9.81a2,2,0,0,0-.78.47L50,69.17,16.86,36a2,2,0,0,0-.78-.47L6.42,25.75a2,2,0,1,0-2.84,2.81l45,45.69a2,2,0,0,0,2.84,0l45-45.69A2,2,0,0,0,96.4,25.73Z"></path></g></svg></span>
            </span>
          </summary>
          <div class="accordion__panel">
            <p>Your items may be subjected to local customs fees and import duties. These charges are to be paid by the customer if imposed.</p>
          </div>
        </details>
        <details class="accordion__item">
          <summary class="accordion__heading">
            <span class="accordion__button" aria-expanded="false" role="button" tabindex="-1">
              Payment Options
              <span class="icon icon--rotate" data-icon="down-caret"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="down-caret"><path stroke="black" stroke-width="2" d="M96.4,25.73a2,2,0,0,0-2.82,0l-9.66,9.81a2,2,0,0,0-.78.47L50,69.17,16.86,36a2,2,0,0,0-.78-.47L6.42,25.75a2,2,0,1,0-2.84,2.81l45,45.69a2,2,0,0,0,2.84,0l45-45.69A2,2,0,0,0,96.4,25.73Z"></path></g></svg></span>
            </span>
          </summary>
          <div class="accordion__panel">
            <p>We accept all major credit cards including Visa, MasterCard, American Express, UnionPay, and Discover. Our system also supports FPS, Alipay HK, Alipay (RMB), WeChat Pay HK, and WeChat Pay (RMB).</p>
          </div>
        </details>
        <details class="accordion__item">
          <summary class="accordion__heading">
            <span class="accordion__button" aria-expanded="false" role="button" tabindex="-1">
              Delivery Attempts & Recipient information
              <span class="icon icon--rotate" data-icon="down-caret"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="down-caret"><path stroke="black" stroke-width="2" d="M96.4,25.73a2,2,0,0,0-2.82,0l-9.66,9.81a2,2,0,0,0-.78.47L50,69.17,16.86,36a2,2,0,0,0-.78-.47L6.42,25.75a2,2,0,1,0-2.84,2.81l45,45.69a2,2,0,0,0,2.84,0l45-45.69A2,2,0,0,0,96.4,25.73Z"></path></g></svg></span>
            </span>
          </summary>
          <div class="accordion__panel">
            <p>Please ensure that you enter the correct delivery information for your order. Additionally, Please make sure that someone is available to receive the delivery and respond to any calls from our courier partners.</p>
            <p>Repeated unsuccessful delivery attempts may result in the parcel being returned to our warehouse. If this occurs, you may incur additional fees when requesting a re-delivery.</p>
          </div>
        </details>
        <details class="accordion__item">
          <summary class="accordion__heading">
            <span class="accordion__button" aria-expanded="false" role="button" tabindex="-1">
              Returns & Refunds
              <span class="icon icon--rotate" data-icon="down-caret"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="down-caret"><path stroke="black" stroke-width="2" d="M96.4,25.73a2,2,0,0,0-2.82,0l-9.66,9.81a2,2,0,0,0-.78.47L50,69.17,16.86,36a2,2,0,0,0-.78-.47L6.42,25.75a2,2,0,1,0-2.84,2.81l45,45.69a2,2,0,0,0,2.84,0l45-45.69A2,2,0,0,0,96.4,25.73Z"></path></g></svg></span>
            </span>
          </summary>
          <div class="accordion__panel">
            <p>Every customer's order is packed and checked thoroughly prior to shipping. However, if the items is damaged during shipping or turn out to be different from what you purchased, please contact us via email immediately.</p>
          </div>
        </details>
        <details class="accordion__item">
          <summary class="accordion__heading">
            <span class="accordion__button" aria-expanded="false" role="button" tabindex="-1">
              Order Cancellation Requests
              <span class="icon icon--rotate" data-icon="down-caret"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="down-caret"><path stroke="black" stroke-width="2" d="M96.4,25.73a2,2,0,0,0-2.82,0l-9.66,9.81a2,2,0,0,0-.78.47L50,69.17,16.86,36a2,2,0,0,0-.78-.47L6.42,25.75a2,2,0,1,0-2.84,2.81l45,45.69a2,2,0,0,0,2.84,0l45-45.69A2,2,0,0,0,96.4,25.73Z"></path></g></svg></span>
            </span>
          </summary>
          <div class="accordion__panel">
            <p>We apologize that it will not be possible to cancel your orders or exchange items once the parcels are shipped.</p>
            <p>Please contact us immediately for any change of order before we ship.</p>
          </div>
        </details>
        <details class="accordion__item">
          <summary class="accordion__heading">
            <span class="accordion__button" aria-expanded="false" role="button" tabindex="-1">
              Public Holidays & Weekends
              <span class="icon icon--rotate" data-icon="down-caret"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="down-caret"><path stroke="black" stroke-width="2" d="M96.4,25.73a2,2,0,0,0-2.82,0l-9.66,9.81a2,2,0,0,0-.78.47L50,69.17,16.86,36a2,2,0,0,0-.78-.47L6.42,25.75a2,2,0,1,0-2.84,2.81l45,45.69a2,2,0,0,0,2.84,0l45-45.69A2,2,0,0,0,96.4,25.73Z"></path></g></svg></span>
            </span>
          </summary>
          <div class="accordion__panel">
            <p>Shipping days do not include public holidays or weekends.</p>
          </div>
        </details>
        <details class="accordion__item">
          <summary class="accordion__heading">
            <span class="accordion__button" aria-expanded="false" role="button" tabindex="-1">
              Wholesale Enquiries
              <span class="icon icon--rotate" data-icon="down-caret"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="down-caret"><path stroke="black" stroke-width="2" d="M96.4,25.73a2,2,0,0,0-2.82,0l-9.66,9.81a2,2,0,0,0-.78.47L50,69.17,16.86,36a2,2,0,0,0-.78-.47L6.42,25.75a2,2,0,1,0-2.84,2.81l45,45.69a2,2,0,0,0,2.84,0l45-45.69A2,2,0,0,0,96.4,25.73Z"></path></g></svg></span>
            </span>
          </summary>
          <div class="accordion__panel">
            <p>We currently only allow companies or resellers to become our wholesaler.</p>
            <p>Proof of company details including business registration, official website, social media accounts might need to be provided in order to qualify for our wholesale pricing.</p>
            <p>Please contact us via email: <a href="mailto:yourexpert@lmching.com">yourexpert@lmching.com</a> for more details</p>
          </div>
        </details>
</div></div>`;

    wrap.querySelectorAll('details.accordion__item').forEach(function (details) {
      var summaryButton = details.querySelector('.accordion__button');
      details.addEventListener('toggle', function () {
        summaryButton.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      });
    });

    return wrap;
  }

  function mount() {
    var rootEl = document.getElementById(ROOT_ID);
    if (!rootEl) return;

    var section = el('div', 'shipping-table-section');
    var searchContainer = el('div', 'shipping-table-search-container');
    searchContainer.appendChild(buildTable());
    section.appendChild(searchContainer);
    section.appendChild(buildTerms());
    section.appendChild(buildFaq());

    rootEl.appendChild(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
})();
